"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nullify = void 0;
var lodash_1 = require("lodash");
var nullify = function (val) {
  if (!val) {
    return null;
  }
  if ((0, lodash_1.isArray)(val) && val.length === 0) {
    return null;
  }
  return val;
};
exports.nullify = nullify;